/**
 * @desc 查询可以申请解冻的记录
 */
import { CanUnfreezeApplyDto } from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryCanUnfreezeApplyParameter = never

const method = 'GET'
const url = '/trade/member/unfreezeApply/canUnfreezeApply'

export const queryCanUnfreezeApplyApi = (
  params?: QueryCanUnfreezeApplyParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<Array<CanUnfreezeApplyDto>>({
    method,
    url,
    params,
    ...config
  })
}

queryCanUnfreezeApplyApi.method = method
queryCanUnfreezeApplyApi.url = url
